export default "__VITE_ASSET__U3r3IBOs__"